import './styles/app.scss';

import { GlobalStyle } from '@met/react-components';
import React, { Fragment } from 'react';
import { Route, Switch } from 'react-router';
import ApiApplications from './containers/ApiApplications';
import ApiApplication from './containers/ApiApplication';

import Home from './containers/Home';
import Layout from './containers/Layout';
import Project from './containers/Project';
import Translations from './containers/Translations';
import Publish from './containers/PublishVersion';
import Translation from './containers/Translation';

const AppRoute = ({ component: Component, layout: Layout, ...rest }) => {
  return (
    <Route
      {...rest}
      render={props => (
        <Layout {...rest} {...props}>
          <Component {...props} />
        </Layout>
      )}
    />
  );
};

export default () => (
  <Fragment>
    <GlobalStyle />
    <Switch>
      <AppRoute exact path='/' component={Home} layout={Layout} />
      <AppRoute
        exact
        path='/projects/:id'
        component={Project}
        layout={Layout}
      />
      <AppRoute
        exact
        path='/projects/:projectId/languages/:languageId/namespaces/:namespaceId/translations'
        component={Translations}
        layout={Layout}
      />
      <AppRoute
        exact
        path='/projects/:projectName/namespaces/:namespaceName/translations/:translationKey'
        component={Translation}
        layout={Layout}
      />
      <AppRoute
        exact
        path='/projects/:id/publish'
        component={Publish}
        layout={Layout}
      />
      <AppRoute
        exact
        path='/apiApplications'
        component={ApiApplications}
        layout={Layout}
      />
      <AppRoute
        exact
        path='/apiApplications/:id'
        component={ApiApplication}
        layout={Layout}
      />
    </Switch>
  </Fragment>
);
